class Alert extends HTMLElement {
  constructor() {
    super();
    this.button = this.getElementsByTagName("button")[0];
  }

  connectedCallback() {
    this.button.addEventListener("click", (event) => {
      event.stopPropagation();
      this.style.opacity = 0;
      setTimeout(() => this.remove(), 250);
    });
  }
}

customElements.define("sitediver-alert", Alert);
